import { render, staticRenderFns } from "./YpoConciergeWrapper.vue?vue&type=template&id=1a0f856b&"
import script from "./YpoConciergeWrapper.vue?vue&type=script&lang=js&"
export * from "./YpoConciergeWrapper.vue?vue&type=script&lang=js&"
import style0 from "./YpoConciergeWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports